import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';
import i18n from '../i18n';

// Loader w stylu „elektrycznym" — pulsujący piorun z rozchodzącym się pierścieniem.
// Domyślny podpis ze słownika; komponent jest poza Reactowym kontekstem tłumaczeń
// w wartości domyślnej argumentu, więc bierzemy go z i18n przy renderze.
const Loader = ({ label = i18n.t('wspolne:ladowanie') }) => (
  <div className="flex flex-col items-center justify-center gap-4">
    <span className="relative flex items-center justify-center">
      <span className="absolute inline-flex h-16 w-16 rounded-full bg-blue-400 opacity-20 animate-ping"></span>
      <span className="relative flex items-center justify-center h-16 w-16 rounded-full bg-blue-50 border border-blue-100">
        <FontAwesomeIcon icon={faBolt} className="text-blue-500 text-2xl animate-pulse" />
      </span>
    </span>
    {label && <span className="text-sm font-medium text-gray-400 tracking-wide">{label}</span>}
  </div>
);

export default Loader;
